import React, { useContext } from 'react';
import classNames from 'classnames';
import DealContext from '../DealContext';
import { Card, ListGroup, Badge } from 'react-bootstrap';

const TeamCard = () => {
  const { team } = useContext(DealContext);

  const hasTeam = Object.keys(team).length > 0;

  return (
    <Card>
      <Card.Body className={classNames({ 'pb-0': hasTeam })}>
        <Card.Title>Team</Card.Title>
        {hasTeam === false && (
          <Card.Text>
            <i>Sales people assigned to quotes in this deal will be displayed here.</i>
          </Card.Text>
        )}
      </Card.Body>
      {hasTeam === true && (
        <ListGroup variant="flush">
          {Object.keys(team).map(assignedTo => {
            return (
              <ListGroup.Item key={assignedTo} className="d-flex">
                <div className="flex-grow-1">
                  {team[assignedTo].firstName} {team[assignedTo].lastName}
                </div>
                <h4 className="mb-0">
                  <Badge pill variant="primary" title="# of quotes">
                    {team[assignedTo].count || 'C'}
                  </Badge>
                </h4>
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      )}
    </Card>
  );
};

export default TeamCard;
